// src/components/analytics/ConditionalClarity.tsx
'use client'

import { useCookieConsentContext } from '@use-cookie-consent/react'
import { ClarityAnalytics } from './ClarityAnalytics' // Path to your existing ClarityAnalytics component

export function ConditionalClarity() {
  const { consent } = useCookieConsentContext()

  // ClarityAnalytics initializes itself via its useEffect when mounted.
  // We only mount it if thirdParty consent is true.
  if (consent.thirdParty === true) {
    return <ClarityAnalytics />
  }

  return null
}
